module.exports = __webpack_public_path__ + "static/img/report-1.e55c6fb7.png";